var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomSavedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 89,
    opacity: 0.8,
    viewBox: "0 0 349 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2562 59.9946C47.9762 60.873 47.767 61.766 47.6256 62.6709L49.2787 61.0174L52.4171 57.8783L55.5555 54.7392L58.6938 51.6002L61.8322 48.4611L62.5129 47.7803C62.1299 47.8392 61.7468 47.9129 61.3666 47.9954C60.2468 48.246 59.1477 48.6026 58.0838 49.0713L57.1261 50.0292L53.9878 53.1682L50.8494 56.3073L48.9222 58.2379C48.6687 58.8126 48.4477 59.3992 48.2591 59.9917L48.2562 59.9946Z",
    fill: "#FFDE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2788 67.2924L52.4171 64.1534L55.5555 61.0143L58.6939 57.8753L61.8323 54.7362L64.9706 51.5971L68.109 48.4581L68.6777 47.8892C68.2298 47.8037 67.7819 47.736 67.331 47.6829C66.8419 47.6269 66.3497 47.5915 65.8576 47.5739L63.4029 50.0291L60.2645 53.1682L57.1262 56.3072L53.9878 59.4463L50.8494 62.5853L47.7111 65.7244L47.4223 66.0132C47.4517 66.9594 47.5578 67.9026 47.7376 68.8369L49.2788 67.2954V67.2924Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4142 70.4287L55.5526 67.2896L58.691 64.1506L61.8294 61.0115L64.9677 57.8725L68.1061 54.7334L71.2445 51.5944L73.3514 49.4869C72.6354 49.1244 71.9016 48.8119 71.1502 48.5496L69.6768 50.0233L66.5384 53.1624L63.4 56.3015L60.2616 59.4405L57.1233 62.5796L53.9849 65.7186L50.8465 68.8577L48.4007 71.3041C48.66 72.0527 48.9723 72.7896 49.3378 73.5059L52.4142 70.4287Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4142 76.7038L55.5526 73.5647L58.691 70.4257L61.8293 67.2866L64.9677 64.1476L68.1061 61.0085L71.2445 57.8694L74.3828 54.7304L77.088 52.0246C76.5222 51.5235 75.9328 51.0667 75.3228 50.6511L72.8151 53.1594L69.6767 56.2984L66.5384 59.4375L63.4 62.5765L60.2616 65.7156L57.1233 68.8547L53.9849 71.9937L50.8465 75.1328L50.5047 75.4747C50.9202 76.0848 51.3769 76.6743 51.8779 77.2402L52.4172 76.7008L52.4142 76.7038Z",
    fill: "#FFDE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5526 79.8427L58.6909 76.7036L61.8293 73.5645L64.9677 70.4255L68.106 67.2864L71.2444 64.1474L74.3828 61.0083L77.5212 57.8692L80.0319 55.358C79.6164 54.7478 79.1566 54.1613 78.6586 53.5954L75.9534 56.3012L72.8151 59.4403L69.6767 62.5793L66.5383 65.7183L63.4 68.8574L60.2616 71.9965L57.1232 75.1355L53.9849 78.2746L53.4456 78.814C54.0114 79.3151 54.5978 79.7719 55.2078 80.1875L55.5526 79.8427Z",
    fill: "#FFDE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8263 79.8426L64.9647 76.7036L68.1031 73.5645L71.2415 70.4254L74.3798 67.2864L77.5182 64.1473L80.6566 61.0083L82.1359 59.5286C81.8736 58.78 81.5612 58.0461 81.1988 57.3298L79.0889 59.4402L75.9505 62.5793L72.8121 65.7183L69.6737 68.8574L66.5354 71.9964L63.397 75.1355L60.2586 78.2746L57.1763 81.3576C57.8923 81.7201 58.6261 82.0355 59.3746 82.2949L61.8263 79.8426Z",
    fill: "#FFDE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9618 82.9786L68.1002 79.8396L71.2385 76.7005L74.3769 73.5615L77.5153 70.4224L80.6536 67.2834L83.1172 64.8193C83.0995 64.3329 83.0641 63.8496 83.0111 63.3662C82.9581 62.9093 82.8873 62.4524 82.8019 61.9985L82.2243 62.5762L79.0859 65.7153L75.9476 68.8544L72.8092 71.9934L69.6708 75.1325L66.5325 78.2715L63.3941 81.4106L61.844 82.961C62.7752 83.1408 63.7182 83.2469 64.6642 83.2793L64.9618 82.9816V82.9786Z",
    fill: "#FFDE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4144 81.8028L74.374 79.8428L77.5124 76.7037L80.6508 73.5646L81.6379 72.5772C82.0976 71.525 82.4483 70.4403 82.6959 69.335C82.7813 68.9459 82.855 68.5539 82.9169 68.1619L82.2214 68.8575L79.083 71.9966L75.9447 75.1356L72.8063 78.2747L69.6679 81.4138L68 83.082C68.9136 82.9406 69.8153 82.7313 70.7023 82.4483C71.2799 82.2626 71.8515 82.0504 72.4144 81.8058V81.8028Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1604 211.98C15.5161 210.403 15.4601 207.791 17.0367 206.147L164.466 52.2857C166.043 50.641 168.654 50.585 170.298 52.1619C171.943 53.7388 171.999 56.3503 170.422 57.995L22.9922 211.856C21.4157 213.501 18.8048 213.557 17.1604 211.98ZM180.353 41.4921C178.711 39.9181 176.106 39.9741 174.533 41.6159C172.959 43.2576 173.015 45.8632 174.657 47.4371C176.298 49.0111 178.903 48.9551 180.477 47.3133C182.05 45.6716 181.994 43.066 180.353 41.4921Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.553 40.1592C152.647 43.1273 152.753 48.0407 149.785 51.1385L-127.632 340.66C-130.599 343.755 -135.512 343.861 -138.609 340.893C-141.703 337.925 -141.809 333.011 -138.841 329.913L138.579 40.3921C141.546 37.2972 146.459 37.1911 149.556 40.1592H149.553Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M345.099 65.5401C348.792 57.2515 350.656 46.9013 347.086 39.1072C339.801 23.2092 318.499 19.9567 307.637 33.4216C304.318 37.5376 300.997 42.1456 295.989 43.8456C286.646 47.0144 277.141 41.6856 267.692 46.6626C257.623 51.9669 250.54 62.9297 238.792 64.9865C231.672 66.2338 225.246 63.5743 218.424 64.3025C215.027 64.6642 211.534 65.4293 208.843 67.5328C201.76 73.0733 203.385 84.4593 207.742 91.0084C211.162 96.1454 216.28 100.01 221.893 102.584C234.666 108.442 249.215 105.347 262.616 103.671C270.646 102.668 278.357 101.051 286.348 100.042C295.238 98.923 304.094 97.1443 312.489 93.9509C323.905 89.611 334.535 82.469 341.36 72.3451C342.706 70.3474 343.987 68.0372 345.099 65.5376V65.5401Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M221.46 50.8137C221.979 50.2941 221.987 49.4593 221.484 48.9299C221.061 49.6711 220.679 50.4271 220.335 51.1978C220.736 51.2495 221.154 51.1215 221.462 50.8137H221.46Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.37 46.9925C223.897 47.5194 224.751 47.5194 225.281 46.9925C225.807 46.4655 225.807 45.6086 225.281 45.0816C225.056 44.8575 224.776 44.7295 224.483 44.6975C223.978 45.2811 223.501 45.8794 223.055 46.4951C223.121 46.6773 223.225 46.8472 223.37 46.9949V46.9925Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M227.191 43.1702C227.718 43.6972 228.572 43.6972 229.101 43.1702C229.628 42.6432 229.628 41.7863 229.101 41.2593C228.934 41.0919 228.732 40.9762 228.518 40.9171C227.932 41.3628 227.358 41.8356 226.802 42.3354C226.829 42.6408 226.96 42.9387 227.193 43.1702H227.191Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M231.012 39.3489C231.539 39.8759 232.393 39.8759 232.922 39.3489C233.277 38.9943 233.393 38.4945 233.269 38.0438C232.479 38.4132 231.704 38.8244 230.945 39.2775C230.968 39.3021 230.987 39.3268 231.012 39.3489Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M218.03 61.2638C218.03 61.333 218.025 61.3996 218.025 61.4688C218.033 61.3996 218.035 61.333 218.03 61.2638Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M221.46 58.4573C221.986 57.9304 221.986 57.0734 221.46 56.5465C220.933 56.0195 220.076 56.0195 219.549 56.5465C219.022 57.0734 219.022 57.9304 219.549 58.4573C220.076 58.9843 220.93 58.9843 221.46 58.4573Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M225.281 54.636C225.807 54.1091 225.807 53.2521 225.281 52.7252C224.754 52.1982 223.897 52.1982 223.37 52.7252C222.843 53.2521 222.843 54.1091 223.37 54.636C223.897 55.163 224.751 55.163 225.281 54.636Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M229.101 50.8138C229.628 50.2868 229.628 49.4299 229.101 48.9029C228.575 48.3759 227.718 48.3759 227.191 48.9029C226.664 49.4299 226.664 50.2868 227.191 50.8138C227.718 51.3407 228.572 51.3407 229.101 50.8138Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.922 46.9925C233.449 46.4655 233.449 45.6086 232.922 45.0816C232.395 44.5546 231.539 44.5546 231.012 45.0816C230.485 45.6086 230.485 46.4655 231.012 46.9925C231.539 47.5194 232.393 47.5194 232.922 46.9925Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M236.743 43.1702C237.27 42.6432 237.27 41.7863 236.743 41.2593C236.216 40.7324 235.36 40.7324 234.833 41.2593C234.306 41.7863 234.306 42.6432 234.833 43.1702C235.36 43.6972 236.214 43.6972 236.743 43.1702Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M240.564 39.3489C241.091 38.822 241.091 37.965 240.564 37.4381C240.037 36.9111 239.181 36.9111 238.654 37.4381C238.127 37.965 238.127 38.822 238.654 39.3489C239.183 39.8759 240.035 39.8759 240.564 39.3489Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M244.358 35.5514C243.764 35.5539 243.169 35.5761 242.575 35.6204C243.097 36.0464 243.86 36.0242 244.358 35.5514Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M219.549 66.1009C220.076 66.6278 220.93 66.6278 221.46 66.1009C221.986 65.5739 221.986 64.717 221.46 64.19C220.933 63.663 220.076 63.663 219.549 64.19C219.022 64.717 219.022 65.5739 219.549 66.1009Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M223.37 62.2796C223.897 62.8065 224.751 62.8065 225.281 62.2796C225.807 61.7526 225.807 60.8957 225.281 60.3687C224.754 59.8418 223.897 59.8418 223.37 60.3687C222.843 60.8957 222.843 61.7526 223.37 62.2796Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M227.191 58.4573C227.718 58.9843 228.572 58.9843 229.101 58.4573C229.628 57.9304 229.628 57.0734 229.101 56.5465C228.575 56.0195 227.718 56.0195 227.191 56.5465C226.664 57.0734 226.664 57.9304 227.191 58.4573Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M231.012 54.636C231.539 55.163 232.393 55.163 232.922 54.636C233.449 54.1091 233.449 53.2521 232.922 52.7252C232.395 52.1982 231.539 52.1982 231.012 52.7252C230.485 53.2521 230.485 54.1091 231.012 54.636Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M234.833 50.8138C235.36 51.3407 236.214 51.3407 236.743 50.8138C237.27 50.2868 237.27 49.4299 236.743 48.9029C236.216 48.3759 235.36 48.3759 234.833 48.9029C234.306 49.4299 234.306 50.2868 234.833 50.8138Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.654 46.9925C239.183 47.5194 240.035 47.5194 240.564 46.9925C241.091 46.4655 241.091 45.6086 240.564 45.0816C240.037 44.5546 239.181 44.5546 238.654 45.0816C238.127 45.6086 238.127 46.4655 238.654 46.9925Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M244.385 43.1702C244.912 42.6432 244.912 41.7863 244.385 41.2593C243.856 40.7324 243.001 40.7324 242.474 41.2593C241.948 41.7863 241.948 42.6432 242.474 43.1702C243.001 43.6972 243.856 43.6972 244.385 43.1702Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M248.206 39.3489C248.733 38.822 248.733 37.965 248.206 37.4381C247.679 36.9111 246.822 36.9111 246.295 37.4381C245.769 37.965 245.769 38.822 246.295 39.3489C246.822 39.8759 247.677 39.8759 248.206 39.3489Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M221.46 71.8333C221.012 71.3852 220.33 71.3187 219.81 71.6314C220.133 72.4613 220.497 73.2788 220.906 74.0791C221.108 74.0151 221.3 73.9043 221.46 73.7442C221.986 73.2172 221.986 72.3603 221.46 71.8333Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M223.37 69.9222C223.897 70.4491 224.751 70.4491 225.281 69.9222C225.807 69.3952 225.807 68.5383 225.281 68.0113C224.754 67.4843 223.897 67.4843 223.37 68.0113C222.843 68.5383 222.843 69.3952 223.37 69.9222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M227.191 66.1009C227.718 66.6278 228.572 66.6278 229.101 66.1009C229.628 65.5739 229.628 64.717 229.101 64.19C228.575 63.663 227.718 63.663 227.191 64.19C226.664 64.717 226.664 65.5739 227.191 66.1009Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M231.012 62.2796C231.539 62.8065 232.393 62.8065 232.922 62.2796C233.449 61.7526 233.449 60.8957 232.922 60.3687C232.395 59.8418 231.539 59.8418 231.012 60.3687C230.485 60.8957 230.485 61.7526 231.012 62.2796Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M234.833 58.4573C235.36 58.9843 236.214 58.9843 236.743 58.4573C237.27 57.9304 237.27 57.0734 236.743 56.5465C236.216 56.0195 235.36 56.0195 234.833 56.5465C234.306 57.0734 234.306 57.9304 234.833 58.4573Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M238.654 54.636C239.183 55.163 240.035 55.163 240.564 54.636C241.091 54.1091 241.091 53.2521 240.564 52.7252C240.037 52.1982 239.181 52.1982 238.654 52.7252C238.127 53.2521 238.127 54.1091 238.654 54.636Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M242.474 50.8138C243.001 51.3407 243.856 51.3407 244.385 50.8138C244.912 50.2868 244.912 49.4299 244.385 48.9029C243.856 48.3759 243.001 48.3759 242.474 48.9029C241.948 49.4299 241.948 50.2868 242.474 50.8138Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M246.295 46.9925C246.822 47.5194 247.677 47.5194 248.206 46.9925C248.733 46.4655 248.733 45.6086 248.206 45.0816C247.679 44.5546 246.822 44.5546 246.295 45.0816C245.769 45.6086 245.769 46.4655 246.295 46.9925Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M252.027 43.1702C252.553 42.6432 252.553 41.7863 252.027 41.2593C251.5 40.7324 250.643 40.7324 250.116 41.2593C249.589 41.7863 249.589 42.6432 250.116 43.1702C250.643 43.6972 251.497 43.6972 252.027 43.1702Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M253.935 37.4381C253.408 37.965 253.408 38.822 253.935 39.3489C254.461 39.8759 255.316 39.8759 255.845 39.3489C256.138 39.0559 256.266 38.6644 256.236 38.2827C255.522 37.9306 254.796 37.6129 254.06 37.3297C254.016 37.3642 253.974 37.3987 253.935 37.4405V37.4381Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M223.37 77.5657C223.897 78.0927 224.751 78.0927 225.281 77.5657C225.807 77.0388 225.807 76.1818 225.281 75.6549C224.754 75.1279 223.897 75.1279 223.37 75.6549C222.843 76.1818 222.843 77.0388 223.37 77.5657Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M227.191 73.7434C227.718 74.2704 228.572 74.2704 229.101 73.7434C229.628 73.2165 229.628 72.3596 229.101 71.8326C228.575 71.3056 227.718 71.3056 227.191 71.8326C226.664 72.3596 226.664 73.2165 227.191 73.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M231.012 69.9222C231.539 70.4491 232.393 70.4491 232.922 69.9222C233.449 69.3952 233.449 68.5383 232.922 68.0113C232.395 67.4843 231.539 67.4843 231.012 68.0113C230.485 68.5383 230.485 69.3952 231.012 69.9222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M234.833 66.1009C235.36 66.6278 236.214 66.6278 236.743 66.1009C237.27 65.5739 237.27 64.717 236.743 64.19C236.216 63.663 235.36 63.663 234.833 64.19C234.306 64.717 234.306 65.5739 234.833 66.1009Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M238.654 62.2796C239.181 62.8065 240.035 62.8065 240.564 62.2796C241.091 61.7526 241.091 60.8957 240.564 60.3687C240.037 59.8418 239.181 59.8418 238.654 60.3687C238.127 60.8957 238.127 61.7526 238.654 62.2796Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M242.474 58.4573C243.001 58.9843 243.856 58.9843 244.385 58.4573C244.912 57.9304 244.912 57.0734 244.385 56.5465C243.856 56.0195 243.001 56.0195 242.474 56.5465C241.948 57.0734 241.948 57.9304 242.474 58.4573Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M246.295 54.636C246.822 55.163 247.677 55.163 248.206 54.636C248.733 54.1091 248.733 53.2521 248.206 52.7252C247.679 52.1982 246.822 52.1982 246.295 52.7252C245.769 53.2521 245.769 54.1091 246.295 54.636Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M250.116 50.8138C250.643 51.3407 251.497 51.3407 252.027 50.8138C252.553 50.2868 252.553 49.4299 252.027 48.9029C251.5 48.3759 250.643 48.3759 250.116 48.9029C249.589 49.4299 249.589 50.2868 250.116 50.8138Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M255.845 46.9925C256.372 46.4655 256.372 45.6086 255.845 45.0816C255.318 44.5546 254.464 44.5546 253.935 45.0816C253.408 45.6086 253.408 46.4655 253.935 46.9925C254.462 47.5194 255.316 47.5194 255.845 46.9925Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M259.668 43.1702C260.195 42.6432 260.195 41.7863 259.668 41.2593C259.142 40.7324 258.285 40.7324 257.758 41.2593C257.231 41.7863 257.231 42.6432 257.758 43.1702C258.285 43.6972 259.139 43.6972 259.668 43.1702Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M227.191 81.388C227.718 81.9149 228.572 81.9149 229.101 81.388C229.628 80.861 229.628 80.0041 229.101 79.4771C228.575 78.9502 227.718 78.9502 227.191 79.4771C226.664 80.0065 226.664 80.861 227.191 81.388Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M231.012 77.5657C231.539 78.0927 232.393 78.0927 232.922 77.5657C233.449 77.0388 233.449 76.1818 232.922 75.6549C232.395 75.1279 231.539 75.1279 231.012 75.6549C230.485 76.1818 230.485 77.0388 231.012 77.5657Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M234.833 73.7434C235.36 74.2704 236.214 74.2704 236.743 73.7434C237.27 73.2165 237.27 72.3596 236.743 71.8326C236.216 71.3056 235.36 71.3056 234.833 71.8326C234.306 72.3596 234.306 73.2165 234.833 73.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M238.654 69.9222C239.181 70.4491 240.035 70.4491 240.564 69.9222C241.091 69.3952 241.091 68.5383 240.564 68.0113C240.037 67.4843 239.181 67.4843 238.654 68.0113C238.127 68.5383 238.127 69.3952 238.654 69.9222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M242.474 66.1009C243.001 66.6278 243.856 66.6278 244.385 66.1009C244.912 65.5739 244.912 64.717 244.385 64.19C243.856 63.663 243.001 63.663 242.474 64.19C241.948 64.717 241.948 65.5739 242.474 66.1009Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M246.295 62.2796C246.822 62.8065 247.677 62.8065 248.206 62.2796C248.733 61.7526 248.733 60.8957 248.206 60.3687C247.679 59.8418 246.822 59.8418 246.295 60.3687C245.769 60.8957 245.769 61.7526 246.295 62.2796Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M250.116 58.4573C250.643 58.9843 251.497 58.9843 252.027 58.4573C252.556 57.9304 252.556 57.0734 252.027 56.5465C251.5 56.0195 250.643 56.0195 250.116 56.5465C249.589 57.0734 249.589 57.9304 250.116 58.4573Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M253.937 54.636C254.464 55.163 255.318 55.163 255.848 54.636C256.374 54.1091 256.374 53.2521 255.848 52.7252C255.321 52.1982 254.466 52.1982 253.937 52.7252C253.41 53.2521 253.41 54.1091 253.937 54.636Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M257.758 50.8138C258.285 51.3407 259.139 51.3407 259.668 50.8138C260.195 50.2868 260.195 49.4299 259.668 48.9029C259.142 48.3759 258.285 48.3759 257.758 48.9029C257.231 49.4299 257.231 50.2868 257.758 50.8138Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M263.489 46.9925C264.016 46.4655 264.016 45.6086 263.489 45.0816C262.963 44.5546 262.106 44.5546 261.579 45.0816C261.052 45.6086 261.052 46.4655 261.579 46.9925C262.106 47.5194 262.96 47.5194 263.489 46.9925Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M232.922 83.2956C232.395 82.7686 231.539 82.7686 231.012 83.2956C230.65 83.6576 230.537 84.1772 230.672 84.6352C231.206 84.9627 231.75 85.2705 232.304 85.5586C232.531 85.4995 232.745 85.3838 232.922 85.2065C233.449 84.6795 233.449 83.8226 232.922 83.2956Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M234.833 81.3851C235.36 81.912 236.214 81.912 236.743 81.3851C237.27 80.8581 237.27 80.0012 236.743 79.4742C236.216 78.9472 235.36 78.9472 234.833 79.4742C234.306 80.0012 234.306 80.8581 234.833 81.3851Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M238.654 77.5657C239.181 78.0927 240.035 78.0927 240.564 77.5657C241.091 77.0388 241.091 76.1818 240.564 75.6549C240.037 75.1279 239.181 75.1279 238.654 75.6549C238.127 76.1818 238.127 77.0388 238.654 77.5657Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M242.474 73.7434C243.001 74.2704 243.856 74.2704 244.385 73.7434C244.912 73.2165 244.912 72.3596 244.385 71.8326C243.856 71.3056 243.001 71.3056 242.474 71.8326C241.948 72.3596 241.948 73.2165 242.474 73.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M246.295 69.9222C246.822 70.4491 247.677 70.4491 248.206 69.9222C248.733 69.3952 248.733 68.5383 248.206 68.0113C247.679 67.4843 246.822 67.4843 246.295 68.0113C245.769 68.5383 245.769 69.3952 246.295 69.9222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M250.116 66.1009C250.643 66.6278 251.497 66.6278 252.027 66.1009C252.556 65.5739 252.556 64.717 252.027 64.19C251.5 63.663 250.643 63.663 250.116 64.19C249.589 64.717 249.589 65.5739 250.116 66.1009Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M253.937 62.2796C254.464 62.8065 255.318 62.8065 255.848 62.2796C256.374 61.7526 256.374 60.8957 255.848 60.3687C255.321 59.8418 254.466 59.8418 253.937 60.3687C253.41 60.8957 253.41 61.7526 253.937 62.2796Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M257.758 58.4573C258.285 58.9843 259.139 58.9843 259.668 58.4573C260.195 57.9304 260.195 57.0734 259.668 56.5465C259.142 56.0195 258.285 56.0195 257.758 56.5465C257.231 57.0734 257.231 57.9304 257.758 58.4573Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M261.579 54.636C262.106 55.163 262.96 55.163 263.489 54.636C264.016 54.1091 264.016 53.2521 263.489 52.7252C262.963 52.1982 262.106 52.1982 261.579 52.7252C261.052 53.2521 261.052 54.1091 261.579 54.636Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M267.308 50.8138C267.835 50.2868 267.835 49.4299 267.308 48.9029C266.781 48.3759 265.924 48.3759 265.397 48.9029C264.87 49.4299 264.87 50.2868 265.397 50.8138C265.924 51.3407 266.778 51.3407 267.308 50.8138Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M236.743 87.1178C236.33 86.7041 235.712 86.6155 235.212 86.8519C235.798 87.071 236.389 87.268 236.984 87.4453C236.923 87.3271 236.842 87.2163 236.743 87.1178Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M238.654 85.2074C239.181 85.7368 240.035 85.7368 240.564 85.2074C241.091 84.6805 241.091 83.8235 240.564 83.2966C240.037 82.7696 239.181 82.7696 238.654 83.2966C238.127 83.8235 238.127 84.6805 238.654 85.2074Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M242.474 81.3851C243.001 81.912 243.856 81.912 244.385 81.3851C244.912 80.8581 244.912 80.0012 244.385 79.4742C243.856 78.9472 243.001 78.9472 242.474 79.4742C241.948 80.0012 241.948 80.8581 242.474 81.3851Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M246.295 77.5657C246.822 78.0927 247.677 78.0927 248.206 77.5657C248.733 77.0388 248.733 76.1818 248.206 75.6549C247.679 75.1279 246.822 75.1279 246.295 75.6549C245.769 76.1818 245.769 77.0388 246.295 77.5657Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M250.116 73.7434C250.643 74.2704 251.497 74.2704 252.027 73.7434C252.556 73.2165 252.556 72.3596 252.027 71.8326C251.5 71.3056 250.643 71.3056 250.116 71.8326C249.589 72.3596 249.589 73.2165 250.116 73.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M253.937 69.9222C254.464 70.4491 255.318 70.4491 255.848 69.9222C256.374 69.3952 256.374 68.5383 255.848 68.0113C255.321 67.4843 254.466 67.4843 253.937 68.0113C253.41 68.5383 253.41 69.3952 253.937 69.9222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M257.758 66.0979C258.285 66.6249 259.139 66.6249 259.668 66.0979C260.195 65.571 260.195 64.714 259.668 64.1871C259.142 63.6601 258.285 63.6601 257.758 64.1871C257.231 64.714 257.231 65.571 257.758 66.0979Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M261.576 62.2796C262.103 62.8065 262.958 62.8065 263.487 62.2796C264.014 61.7526 264.014 60.8957 263.487 60.3687C262.96 59.8418 262.103 59.8418 261.576 60.3687C261.05 60.8957 261.05 61.7526 261.576 62.2796Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M265.4 58.4573C265.927 58.9843 266.781 58.9843 267.31 58.4573C267.837 57.9304 267.837 57.0734 267.31 56.5465C266.783 56.0195 265.927 56.0195 265.4 56.5465C264.873 57.0734 264.873 57.9304 265.4 58.4573Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M269.218 54.6363C269.45 54.8678 269.745 54.9983 270.045 55.0254C269.829 54.23 269.573 53.4445 269.28 52.6664C269.258 52.6861 269.238 52.7033 269.216 52.723C268.689 53.25 268.689 54.1069 269.216 54.6339L269.218 54.6363Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M244.385 87.1178C243.856 86.5909 243.001 86.5909 242.474 87.1178C242.12 87.4724 242.007 87.9723 242.127 88.423C242.984 88.4993 243.843 88.5338 244.702 88.5288C244.872 88.0511 244.769 87.4995 244.387 87.1178H244.385Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M246.295 85.2074C246.822 85.7368 247.677 85.7368 248.206 85.2074C248.733 84.6805 248.733 83.8235 248.206 83.2966C247.679 82.7696 246.822 82.7696 246.295 83.2966C245.769 83.8235 245.769 84.6805 246.295 85.2074Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M250.116 81.3851C250.643 81.912 251.497 81.912 252.027 81.3851C252.556 80.8581 252.556 80.0012 252.027 79.4742C251.5 78.9472 250.643 78.9472 250.116 79.4742C249.589 80.0012 249.589 80.8581 250.116 81.3851Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M253.937 77.5638C254.464 78.0907 255.318 78.0907 255.848 77.5638C256.374 77.0368 256.374 76.1799 255.848 75.6529C255.321 75.1259 254.466 75.1259 253.937 75.6529C253.41 76.1799 253.41 77.0368 253.937 77.5638Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M257.758 73.7434C258.285 74.2704 259.139 74.2704 259.668 73.7434C260.195 73.2165 260.195 72.3596 259.668 71.8326C259.142 71.3056 258.285 71.3056 257.758 71.8326C257.231 72.3596 257.231 73.2165 257.758 73.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M261.576 69.9222C262.103 70.4491 262.958 70.4491 263.487 69.9222C264.014 69.3952 264.014 68.5383 263.487 68.0113C262.96 67.4843 262.103 67.4843 261.576 68.0113C261.05 68.5383 261.05 69.3952 261.576 69.9222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M265.4 66.0979C265.927 66.6249 266.781 66.6249 267.31 66.0979C267.837 65.571 267.837 64.714 267.31 64.1871C266.783 63.6601 265.927 63.6601 265.4 64.1871C264.873 64.714 264.873 65.571 265.4 66.0979Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M269.218 62.2789C269.701 62.7615 270.454 62.8009 270.983 62.402C270.993 61.6682 270.974 60.9319 270.924 60.2006C270.4 59.8484 269.681 59.9051 269.218 60.368C268.691 60.895 268.691 61.7519 269.218 62.2789Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M252.024 87.1183C251.497 86.5913 250.641 86.5913 250.114 87.1183C249.865 87.367 249.735 87.6896 249.722 88.0146C250.567 87.8447 251.404 87.6354 252.231 87.3843C252.174 87.2907 252.108 87.1996 252.027 87.1183H252.024Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M253.937 85.2074C254.464 85.7368 255.318 85.7368 255.848 85.2074C256.374 84.6805 256.374 83.8235 255.848 83.2966C255.321 82.7696 254.466 82.7696 253.937 83.2966C253.41 83.8235 253.41 84.6805 253.937 85.2074Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M257.756 81.3851C258.282 81.912 259.137 81.912 259.666 81.3851C260.193 80.8581 260.193 80.0012 259.666 79.4742C259.139 78.9472 258.282 78.9472 257.756 79.4742C257.229 80.0012 257.229 80.8581 257.756 81.3851Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M261.576 77.5638C262.103 78.0907 262.958 78.0907 263.487 77.5638C264.014 77.0368 264.014 76.1799 263.487 75.6529C262.96 75.1259 262.103 75.1259 261.576 75.6529C261.05 76.1799 261.05 77.0368 261.576 77.5638Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M265.4 73.7434C265.927 74.2704 266.781 74.2704 267.31 73.7434C267.837 73.2165 267.837 72.3596 267.31 71.8326C266.783 71.3056 265.927 71.3056 265.4 71.8326C264.873 72.3596 264.873 73.2165 265.4 73.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M269.218 68.0118C268.691 68.5388 268.691 69.3957 269.218 69.9227C269.358 70.063 269.523 70.164 269.696 70.2305C269.971 69.376 270.205 68.5092 270.392 67.635C269.976 67.5661 269.538 67.6917 269.218 68.0118Z",
    fill: "#67CFEE"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M319.321 46.8271H319.674C320.444 46.8271 321.073 47.4602 321.073 48.2362V48.5909C321.073 49.3669 320.444 50 319.674 50H319.321C318.551 50 317.922 49.3669 317.922 48.5909V48.2362C317.922 47.4602 318.551 46.8271 319.321 46.8271ZM325.909 47.3789L326.029 47.7139C326.293 48.4431 327.1 48.8225 327.822 48.5564L328.154 48.4357C328.878 48.1697 329.255 47.3568 328.991 46.6301L328.871 46.295C328.607 45.5659 327.8 45.1865 327.078 45.4525L326.745 45.5732C326.021 45.8393 325.645 46.6522 325.909 47.3789ZM333.123 43.8218L333.35 44.0952C333.844 44.6889 334.732 44.7677 335.322 44.2701L335.593 44.041C336.183 43.5434 336.261 42.6492 335.767 42.0555L335.539 41.782C335.045 41.1884 334.157 41.1095 333.568 41.6071L333.296 41.8362C332.707 42.3338 332.628 43.2281 333.123 43.8218ZM338.692 37.9933L338.998 38.1707C339.666 38.5574 340.525 38.3259 340.911 37.6558L341.087 37.3479C341.471 36.6754 341.241 35.8107 340.576 35.4215L340.27 35.2441C339.602 34.8574 338.744 35.0889 338.357 35.759L338.181 36.0669C337.797 36.7394 338.027 37.6041 338.692 37.9933ZM341.948 30.5981L342.296 30.6597C343.054 30.7952 343.783 30.2803 343.917 29.5167L343.979 29.1669C344.113 28.4032 343.602 27.6691 342.843 27.5336L342.496 27.472C341.738 27.3366 341.009 27.8514 340.874 28.6151L340.813 28.9649C340.679 29.7285 341.19 30.4626 341.948 30.5981ZM342.496 22.528L342.843 22.4664C343.602 22.3309 344.113 21.5968 343.979 20.8331L343.917 20.4833C343.783 19.7197 343.054 19.2048 342.296 19.3403L341.948 19.4019C341.19 19.5374 340.679 20.2715 340.813 21.0351L340.874 21.3849C341.009 22.1486 341.738 22.6634 342.496 22.528ZM340.27 14.7559L340.576 14.5785C341.244 14.1918 341.474 13.3246 341.087 12.6521L340.911 12.3442C340.527 11.6717 339.666 11.4401 338.998 11.8293L338.692 12.0067C338.025 12.3935 337.795 13.2606 338.181 13.9331L338.357 14.241C338.741 14.9135 339.602 15.1451 340.27 14.7559ZM335.539 8.22043L335.767 7.94699C336.261 7.35331 336.185 6.45907 335.593 5.96146L335.322 5.73238C334.732 5.23477 333.844 5.31113 333.35 5.90727L333.123 6.18071C332.628 6.77439 332.704 7.66863 333.296 8.16624L333.568 8.39532C334.157 8.89293 335.045 8.81657 335.539 8.22043ZM328.874 3.70746L328.993 3.37241C329.258 2.64323 328.881 1.83032 328.157 1.56673L327.824 1.44603C327.1 1.17998 326.293 1.55935 326.031 2.28852L325.911 2.62355C325.647 3.35272 326.024 4.16564 326.748 4.42922L327.081 4.54993C327.805 4.81598 328.612 4.43663 328.874 3.70746ZM321.078 1.76382V1.40907C321.078 0.633091 320.449 0 319.679 0H319.326C318.556 0 317.927 0.633091 317.927 1.40907V1.76382C317.927 2.53979 318.556 3.17289 319.326 3.17289H319.679C320.449 3.17289 321.078 2.53979 321.078 1.76382ZM313.091 2.62108L312.971 2.28606C312.707 1.55689 311.9 1.17751 311.178 1.44356L310.846 1.56427C310.122 1.83031 309.745 2.64326 310.009 3.36997L310.129 3.70499C310.393 4.43417 311.2 4.81351 311.922 4.54746L312.255 4.42676C312.979 4.16071 313.355 3.34779 313.091 2.62108ZM305.877 6.17825L305.65 5.90481C305.156 5.31112 304.268 5.2323 303.678 5.72992L303.407 5.959C302.817 6.45661 302.739 7.35084 303.233 7.94453L303.461 8.21796C303.955 8.81165 304.843 8.89046 305.432 8.39286L305.704 8.16377C306.293 7.66616 306.372 6.77193 305.877 6.17825ZM300.308 12.0067L300.002 11.8293C299.334 11.4426 298.475 11.6741 298.089 12.3442L297.913 12.6521C297.529 13.3246 297.759 14.1893 298.424 14.5785L298.73 14.7559C299.398 15.1426 300.256 14.9111 300.643 14.241L300.819 13.9331C301.203 13.2606 300.973 12.3959 300.308 12.0067ZM297.052 19.4019L296.704 19.3403C295.946 19.2048 295.217 19.7197 295.083 20.4833L295.021 20.8331C294.887 21.5968 295.398 22.3309 296.157 22.4664L296.504 22.528C297.262 22.6634 297.991 22.1486 298.126 21.3849L298.187 21.0351C298.321 20.2715 297.81 19.5374 297.052 19.4019ZM296.504 27.472L296.157 27.5336C295.398 27.6691 294.887 28.4032 295.021 29.1669L295.083 29.5167C295.217 30.2803 295.946 30.7952 296.704 30.6597L297.052 30.5981C297.81 30.4626 298.321 29.7285 298.187 28.9649L298.126 28.6151C297.991 27.8514 297.262 27.3366 296.504 27.472ZM298.73 35.2441L298.424 35.4215C297.756 35.8083 297.526 36.6754 297.913 37.3479L298.089 37.6558C298.473 38.3283 299.334 38.5599 300.002 38.1707L300.308 37.9933C300.975 37.6065 301.205 36.7394 300.819 36.0669L300.643 35.759C300.259 35.0865 299.398 34.8549 298.73 35.2441ZM303.461 41.7796L303.233 42.053C302.739 42.6467 302.815 43.5409 303.407 44.0385L303.678 44.2676C304.268 44.7652 305.156 44.6889 305.65 44.0927L305.877 43.8193C306.372 43.2256 306.296 42.3314 305.704 41.8338L305.432 41.6047C304.843 41.1071 303.955 41.1834 303.461 41.7796ZM310.126 46.2926L310.007 46.6276C309.742 47.3568 310.119 48.1697 310.843 48.4333L311.176 48.554C311.9 48.82 312.707 48.4407 312.969 47.7115L313.089 47.3765C313.353 46.6473 312.976 45.8344 312.252 45.5708L311.919 45.4501C311.195 45.184 310.388 45.5634 310.126 46.2926Z",
    fill: "#FFDE00"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M284 57C281.239 57 279 59.2386 279 62C279 64.7614 281.239 67 284 67C286.761 67 289 64.7614 289 62C289 59.2386 286.761 57 284 57Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M303.5 34C297.149 34 292 39.1487 292 45.5C292 51.8513 297.149 57 303.5 57C309.851 57 315 51.8513 315 45.5C315 39.1487 309.851 34 303.5 34Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomSavedImage);
export default __webpack_public_path__ + "static/media/bottomSavedImage.453ed77d1b77a66193138e98798c90c4.svg";
export { ForwardRef as ReactComponent };